import {
	TTableStructure,
	ETableStructureType,
	ETableStructureAlign,
} from '../../../../../ui/EasTable/types';
import { TEmInvoiceListItem } from '../../../../../redux/reducers/emManagement/types';
import { EReportInvoicePaymentStatus } from '../../../../../redux/reducers/fiscalReports/constants';

export const tableStructure: TTableStructure<keyof TEmInvoiceListItem, TEmInvoiceListItem>[] = [
	{
		name: 'Invoice Number',
		selector: 'invoice_number',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.INVOICE_NUMBER,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Invoice Date',
		selector: 'invoice_date',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Amount',
		selector: 'total_invoice_amount_in_eur',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
	},
	{
		name: 'EAS Fee',
		selector: 'eas_fee_with_vat_on_eas_fee',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
	},
	{
		name: 'Payment Status',
		selector: 'payment_status',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.LEFT,
		filter: [
			[EReportInvoicePaymentStatus.PAID, 'Paid'],
			[EReportInvoicePaymentStatus.PENDING, 'Pending'],
			[EReportInvoicePaymentStatus.PARTIALLY_PAID, 'Partially Paid'],
			[EReportInvoicePaymentStatus.OVERDUE, 'Overdue'],
			[EReportInvoicePaymentStatus.NO_INVOICE_FOUND, 'No Invoice Found'],
		],
		colors: [
			[EReportInvoicePaymentStatus.PAID, 'success.light'],
			[EReportInvoicePaymentStatus.PENDING, 'info.light'],
			[EReportInvoicePaymentStatus.PARTIALLY_PAID, 'warning.light'],
			[EReportInvoicePaymentStatus.OVERDUE, 'error.light'],
			[EReportInvoicePaymentStatus.NO_INVOICE_FOUND, 'error.light'],
		],
	},
	{
		name: 'Service Type',
		selector: 'service_type',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
];
